export default __webpack_public_path__ + "static/media/browsefile.fc0cef0e.svg";